import { type ArcanaImageConfig } from '../../types/arcana-image-config';
import { ArcanaIdentities } from './arcana-identities';

export const ARCANA_IMAGE_URI: ArcanaImageConfig = {
    [ArcanaIdentities.BACK]: [
        {
            uri: 'https://i.pinimg.com/736x/7a/f5/8f/7af58f88d6f893ab99fbf9b2ee4c490a.jpg',
        },
        {
            uri: 'https://artisantarot.com/cdn/shop/files/Crowley-Thoth-Tarot-Deck-Small-Back-Design.jpg?v=1747565632',
            scale: 1.15,
            scaleX: 1.29,
            scaleY: 1.19,
            offsetX: 4,
        }
    ],
    [ArcanaIdentities.THE_FOOL]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/01/Atu0_thothfool.jpg',
        },
        {
            uri: 'https://freight.cargo.site/t/original/i/464c849263bd363a083e2ec8e8020052127f0bb7a61521b10362b406f4c1bd8a/Atu-0---The-Fool.jpg',
        },
    ],
    [ArcanaIdentities.THE_MAGUS]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/346408_281718.jpg',
        },
    ],
    [ArcanaIdentities.THE_PRIESTESS]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/516767_341591.jpg',
        },
    ],
    [   ArcanaIdentities.THE_EMPRESS]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/620834_752691.jpg',
        },
    ],
    [ArcanaIdentities.THE_EMPEROR]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/363871_375179.jpg',
        },
    ],
    [ArcanaIdentities.THE_HIEROPHANT]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/717175_775611.jpg',
        },
    ],
    [ArcanaIdentities.THE_LOVERS]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/579171_265440.jpg',
        },
    ],
    [ArcanaIdentities.THE_CHARIOT]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/04/Chariot_thothtarotcard.jpg',
        },
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/The_Chariot_thoth_bjvdcm.jpg',    
        },
    ],
    [ArcanaIdentities.ADJUSTMENT]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/06/adjustment-thothtarotcard.jpg',
        },
    ],
    [ArcanaIdentities.THE_HERMIT]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/The_Hermit_Thoth_ouulja.jpg',    
        },
    ],
    [ArcanaIdentities.FORTUNE]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/07/fortune-tarot-crowley-thoth.jpg',
        },
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/856105_786763.png',
        }
    ],
    [ArcanaIdentities.LUST]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Lust_thlnm5.jpg',    
        }
    ],
    [ArcanaIdentities.THE_HANGED_MAN]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/The_Hanged_man_Thoth_ae28kx.jpg',
        },
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/352646_42304.png',    
        }
    ],
    [ArcanaIdentities.DEATH]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/15367_361517.jpg',    
        }
    ],
    [ArcanaIdentities.ART]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2017/01/thoth-artcard-hd.jpg',
        },
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/836148_364141.jpg',
        }
    ],
    [ArcanaIdentities.THE_DEVIL]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/The_Devil_Thoth_pe2alt.jpg',    
        }
    ],
    [ArcanaIdentities.THE_TOWER]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/305373_605995.png',    
        }
    ],
    [ArcanaIdentities.THE_STAR]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/star-thoth_el49uv.jpg',    
        }
    ],
    [ArcanaIdentities.THE_MOON]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/The_Moon_Thoth_b7p1ia.jpg',    
        }
    ],
    [ArcanaIdentities.THE_SUN]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2017/05/thothsuntarot_large.jpg',    
        }
    ],
    [ArcanaIdentities.THE_AEON]: [
        {
            uri: 'https://www.esotericmeanings.com/wp-content/uploads/2017/06/Thoth_Aeon_majorArcana.jpg',
        },
        {
            uri: 'https://freight.cargo.site/w/813/q/94/i/5c09f5ac92d24bd6a2de090aff5e8b9c05c3b2fec738eabbc815d2d4b1bca395/Atu-XX---The-Aeon.jpg',    
        }
    ],
    [ArcanaIdentities.THE_UNIVERSE]: [
        {
            uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Key_21-The_Universe_loq9ri.jpg',
        }
    ],

    // Cups
    [ArcanaIdentities.ACE_OF_CUPS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Ace_of_Cups_thoth_l2czb9.jpg' }],
    [ArcanaIdentities.LOVE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/681264_507326.png' }],
    [ArcanaIdentities.ABUNDANCE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_3000,w_2000,f_auto,q_auto/867803/127372_526346.jpeg' }],
    [ArcanaIdentities.LUXURY]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/4_of_cups_thoth_sacmi8.jpg' }],
    [ArcanaIdentities.DISAPPOINTMENT]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/5_of_cups_thoth_attgdt.jpg' }],
    [ArcanaIdentities.PLEASURE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/391897_924694.jpg' }],
    [ArcanaIdentities.DEBAUCH]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/7_of_cups_thoth_judzwt.jpg' }],
    [ArcanaIdentities.INDOLENCE]: [{ uri: 'https://tarot-training.co.uk/wp-content/uploads/2012/05/57-minor-cups-081.jpg' }],
    [ArcanaIdentities.HAPPINESS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/9_of_cups_thoth_ydhgjp.jpg' }],
    [ArcanaIdentities.SATIETY]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/10_of_cups_thoth_fkivll.jpg' }],
    [ArcanaIdentities.PRINCESS_OF_CUPS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Princess_of_cups_thoth_mkn6t3.jpg' }],
    [ArcanaIdentities.PRINCE_OF_CUPS]: [{ uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/02/court-prince-of-cups-1.jpg' }],
    [ArcanaIdentities.QUEEN_OF_CUPS]: [{ uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/01/q-1.jpg' }],
    [ArcanaIdentities.KNIGHT_OF_CUPS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Knight_of_Cups_thoth_fqeley.jpg' }],

    // Disks
    [ArcanaIdentities.ACE_OF_DISKS]: [{ uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/02/thothtarotlessons_aceofdisks.jpg' }],
    [ArcanaIdentities.CHANGE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/2_of_Disks_Thoth_mctncp.jpg' }],
    [ArcanaIdentities.WORKS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/316921_215741.jpg' }],
    [ArcanaIdentities.POWER]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/374657_177790.png' }],
    [ArcanaIdentities.WORRY]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/717940_980354.jpg' }],
    [ArcanaIdentities.SUCCESS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/742185_437151.png' }],
    [ArcanaIdentities.FAILURE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/545883_96688.jpeg' }],
    [ArcanaIdentities.PRUDENCE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/848471_453588.png' }],
    [ArcanaIdentities.GAIN]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/9_of_Disks_Thoth_vpcpce.jpg' }],
    [ArcanaIdentities.WEALTH]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/10_of_Disks_thoth_ifsvs1.jpg' }],
    [ArcanaIdentities.PRINCESS_OF_DISKS]: [{ uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/02/princessofdisks-thothtarot.jpg' }],
    [ArcanaIdentities.PRINCE_OF_DISKS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/589321_197764.jpeg' }],
    [ArcanaIdentities.QUEEN_OF_DISKS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/219731_400869.jpg' }],
    [ArcanaIdentities.KNIGHT_OF_DISKS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/667004_282631.png' }],

    // Swords
    [ArcanaIdentities.ACE_OF_SWORDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Ace_of_Swords_thoth_fycvbc.jpg' }],
    [ArcanaIdentities.PEACE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/740880_1959.jpg' }],
    [ArcanaIdentities.SORROW]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/3_of_Swords_Thoth_eincey.jpg' }],
    [ArcanaIdentities.TRUCE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/4_of_Swords_Thoth_mrjhob.jpg' }],
    [ArcanaIdentities.DEFEAT]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/241107_300452.png' }],
    [ArcanaIdentities.SCIENCE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/6_of_Swords_Thoth_ocxhtr.jpg' }],
    [ArcanaIdentities.FUTILITY]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/7_of_Sword_Thoth_du4lje.jpg' }],
    [ArcanaIdentities.INTERFERENCE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/734725_224719.png' }],
    [ArcanaIdentities.CRUELTY]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/9_of_Swords_Thoth_rtw6in.jpg' }],
    [ArcanaIdentities.RUIN]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/332826_581343.jpg' }],
    [ArcanaIdentities.PRINCESS_OF_SWORDS]: [{ uri: 'https://jenwytch.wordpress.com/wp-content/uploads/2015/01/swords-14-princess.jpg' }],
    [ArcanaIdentities.PRINCE_OF_SWORDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Prince_of_Swords_thoth_pf8de8.jpg' }],
    [ArcanaIdentities.QUEEN_OF_SWORDS]: [{ uri: 'https://www.esotericmeanings.com/wp-content/uploads/2016/01/Queenofswords_thothtarot.jpg' }],
    [ArcanaIdentities.KNIGHT_OF_SWORDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Knight_of_Swords_thoth_auecht.jpg' }],

    // Wands
    [ArcanaIdentities.ACE_OF_WANDS]: [{ uri: 'https://www.esotericmeanings.com/wp-content/uploads/2018/03/1ofwandsupright_thoth.jpg' }],
    [ArcanaIdentities.DOMINION]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_3000,w_2000,f_auto,q_auto/867803/201361_292431.jpeg' }],
    [ArcanaIdentities.VIRTUE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/549964_264267.png' }],
    [ArcanaIdentities.COMPLETION]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/592580_907213.png' }],
    [ArcanaIdentities.STRIFE]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/792785_410503.png' }],
    [ArcanaIdentities.VICTORY]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_1/867803/733187_143057.jpg' }],
    [ArcanaIdentities.VALOUR]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/425409_837008.png' }],
    [ArcanaIdentities.SWIFTNESS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/903919_224340.png' }],
    [ArcanaIdentities.STRENGTH]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/9_of_Wands_Thoth_xhm8zi.jpg' }],
    [ArcanaIdentities.OPPRESSION]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/550562_982082.jpeg' }],
    [ArcanaIdentities.PRINCESS_OF_WANDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/317447_101150.png' }],
    [ArcanaIdentities.PRINCE_OF_WANDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Prince_of_Wands_Thoth_ljri4q.jpg' }],
    [ArcanaIdentities.QUEEN_OF_WANDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/907737_912381.png' }],
    [ArcanaIdentities.KNIGHT_OF_WANDS]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/Knight_of_Wands_Thoth_dwixcw.jpg' }],

    // Special
    [ArcanaIdentities.THELEMA]: [{ uri: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/867803/hexaculum_hpo8nd.jpg' }],
};